import { Routes } from "@angular/router";
import { AuthGuard } from "./_guards/auth.guard";
import { SociosanitaryGuard } from "./_guards/sociosanitary.guard";
import { environment } from "src/environments/environment";
import { PublicRedirectionGuard } from "./_guards/public-redirection.guard";
import { FlowNavigationGuard } from "./_guards/flow-navigation.guard";
const ɵ0 = { title: "routeTitles.login" }, ɵ1 = () => import("./_modules/login/login.module.ngfactory").then(m => m.LoginPageModuleNgFactory), ɵ2 = { title: "routeTitles.recovery" }, ɵ3 = () => import("./_modules/recovery/recovery.module.ngfactory").then(m => m.RecoveryPageModuleNgFactory), ɵ4 = { title: "routeTitles.changePassword" }, ɵ5 = () => import("./_modules/changepassword/changepassword.module.ngfactory").then(m => m.ChangepasswordPageModuleNgFactory), ɵ6 = { title: "routeTitles.santanderPortugalAutologinToken" }, ɵ7 = () => import("./_modules/mock/auth-strategy/santander-portugal-autologin-token/santander-portugal-autologin-token.module.ngfactory").then(m => m.AutologinTokenPageModuleNgFactory), ɵ8 = { title: "routeTitles.about", type: "0" }, ɵ9 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ10 = { title: "routeTitles.beneficiaries", type: "1" }, ɵ11 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ12 = { title: "routeTitles.faq", type: "2" }, ɵ13 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ14 = { title: "routeTitles.id4", type: "3" }, ɵ15 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ16 = { title: "routeTitles.id5", type: "4" }, ɵ17 = () => import("./_modules/page-details/page-details.module.ngfactory").then(m => m.PageDetailsPageModuleNgFactory), ɵ18 = { title: "routeTitles.serviceIndex" }, ɵ19 = () => import("./_modules/service-index/service-index.module.ngfactory").then(m => m.ServiceIndexPageModuleNgFactory), ɵ20 = { title: "routeTitles.serviceDetails" }, ɵ21 = () => import("./_modules/service-details/service-details.module.ngfactory").then(m => m.ServiceDetailsPageModuleNgFactory), ɵ22 = { title: "routeTitles.serviceAvailability" }, ɵ23 = () => import("./_modules/service-availability/service-availability.module.ngfactory").then(m => m.ServiceAvailabilityPageModuleNgFactory), ɵ24 = { title: "routeTitles.serviceAvailability" }, ɵ25 = () => import("./_modules/service-availability-static/service-availability-static.module.ngfactory").then(m => m.ServiceAvailabilityStaticPageModuleNgFactory), ɵ26 = { title: "routeTitles.serviceRequest" }, ɵ27 = () => import("./_modules/service-request/service-request.module.ngfactory").then(m => m.ServiceRequestPageModuleNgFactory), ɵ28 = { title: "routeTitles.contact" }, ɵ29 = () => import("./_modules/contact/contact.module.ngfactory").then(m => m.ContactPageModuleNgFactory), ɵ30 = { title: "routeTitles.feature" }, ɵ31 = () => import("./_modules/feature/feature.module.ngfactory").then(m => m.FeaturePageModuleNgFactory), ɵ32 = { title: "routeTitles.sociosanitary" }, ɵ33 = () => import("./_modules/sociosanitary/sociosanitary.module.ngfactory").then(m => m.SociosanitaryPageModuleNgFactory), ɵ34 = { title: "routeTitles.personalArea" }, ɵ35 = () => import("./_modules/personal-area/personal-area-index/personal-area-index.module.ngfactory").then(m => m.PersonalAreaIndexPageModuleNgFactory), ɵ36 = { title: "routeTitles.personalAreaMyData" }, ɵ37 = () => import("./_modules/personal-area/user/user.module.ngfactory").then(m => m.UserPageModuleNgFactory), ɵ38 = { title: "routeTitles.personalAreaMyServices" }, ɵ39 = () => import("./_modules/personal-area/user-services/user-services.module.ngfactory").then(m => m.UserServicesPageModuleNgFactory), ɵ40 = { title: "routeTitles.personalAreaMyBeneficiaries" }, ɵ41 = () => import("./_modules/personal-area/beneficiary/beneficiary.module.ngfactory").then(m => m.BeneficiaryPageModuleNgFactory), ɵ42 = { title: "routeTitles.personalAreaRequestDetails" }, ɵ43 = () => import("./_modules/personal-area/request-details/request-details.module.ngfactory").then(m => m.RequestDetailsPageModuleNgFactory), ɵ44 = { title: "routeTitles.personalAreaStockDetails" }, ɵ45 = () => import("./_modules/personal-area/stock-details/stock-details.module.ngfactory").then(m => m.StockDetailsPageModuleNgFactory), ɵ46 = { title: "routeTitles.vipSearchAirport" }, ɵ47 = () => import("./_modules/dragonpass/search-airport/search-airport.module.ngfactory").then(m => m.SearchAirportPageModuleNgFactory), ɵ48 = { title: "routeTitles.vipTerminalDetails" }, ɵ49 = () => import("./_modules/dragonpass/terminal-details/terminal-details.module.ngfactory").then(m => m.TerminalDetailsPageModuleNgFactory), ɵ50 = { title: "routeTitles.vipResourceDetails" }, ɵ51 = () => import("./_modules/dragonpass/resource-details/resource-details.module.ngfactory").then(m => m.ResourceDetailsPageModuleNgFactory), ɵ52 = { title: "routeTitles.vipCheckAvailability" }, ɵ53 = () => import("./_modules/dragonpass/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ54 = { title: "routeTitles.vipForm" }, ɵ55 = () => import("./_modules/forms/dragonpass/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ56 = { title: "routeTitles.vipForm" }, ɵ57 = () => import("./_modules/forms/vip-room-whatsapp/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ58 = { title: "Detalle de recurso" }, ɵ59 = () => import("./_modules/forms/fast-track/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ60 = { title: "Detalle de recurso" }, ɵ61 = () => import("./_modules/forms/beauty/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ62 = { title: "routeTitles.hairdressingForm" }, ɵ63 = () => import("./_modules/forms/hairdressing/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ64 = { title: "routeTitles.forceError" }, ɵ65 = () => import("./_modules/force-error/force-error.module.ngfactory").then(m => m.ForceErrorPageModuleNgFactory), ɵ66 = { title: "routeTitles.esimCheckAvailability" }, ɵ67 = () => import("./_modules/e-sim-flag/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ68 = { title: "routeTitles.esimForm" }, ɵ69 = () => import("./_modules/forms/e-sim-flag/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ70 = { title: "routeTitles.transferCheckAvailability" }, ɵ71 = () => import("./_modules/transfer/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ72 = { title: "routeTitles.transferForm" }, ɵ73 = () => import("./_modules/forms/transfer/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ74 = { title: "Formulario Transfer" }, ɵ75 = () => import("./_modules/forms/uber/uber-form.module.ngfactory").then(m => m.UberFormPageModuleNgFactory), ɵ76 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "handyman",
        stockSessionKey: "handyman-stock-quantity"
    }
}, ɵ77 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ78 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "experience-generic-companions",
        stockSessionKey: "experience-generic-companions-stock-quantity"
    }
}, ɵ79 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ80 = { title: "routeTitles.serviceRequest" }, ɵ81 = () => import("./_modules/forms/experience-generic-companions/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ82 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "experience-exclusive-companions",
        stockSessionKey: "experience-exclusive-companions-stock-quantity"
    }
}, ɵ83 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ84 = { title: "routeTitles.serviceRequest" }, ɵ85 = () => import("./_modules/forms/experience-exclusive-companions/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ86 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "experience-generic",
        stockSessionKey: "experience-generic-stock-quantity"
    }
}, ɵ87 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ88 = { title: "routeTitles.serviceRequest" }, ɵ89 = () => import("./_modules/forms/experience-generic/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ90 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "experience-exclusive",
        stockSessionKey: "experience-exclusive-stock-quantity"
    }
}, ɵ91 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ92 = { title: "routeTitles.serviceRequest" }, ɵ93 = () => import("./_modules/forms/experience-exclusive/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ94 = { title: "routeTitles.serviceRequest" }, ɵ95 = () => import("./_modules/forms/physiotherapy/no-justification/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ96 = { title: "routeTitles.serviceRequest" }, ɵ97 = () => import("./_modules/forms/physiotherapy/justification/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ98 = { title: "routeTitles.serviceRequest" }, ɵ99 = () => import("./_modules/forms/psychology/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ100 = { title: "routeTitles.serviceRequest" }, ɵ101 = () => import("./_modules/forms/handyman/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ102 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "sad",
        stockSessionKey: "home-service-stock-quantity"
    }
}, ɵ103 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ104 = { title: "routeTitles.serviceRequest" }, ɵ105 = () => import("./_modules/forms/home-service/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ106 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "carpentry",
        stockSessionKey: "carpentry-stock-quantity"
    }
}, ɵ107 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ108 = { title: "routeTitles.serviceRequest" }, ɵ109 = () => import("./_modules/forms/carpentry/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ110 = {
    title: "routeTitles.serviceAvailability",
    flowConfig: {
        formSegment: "gardening",
        stockSessionKey: "gardening-stock-quantity"
    }
}, ɵ111 = () => import("./_modules/services/availability/availability.module.ngfactory").then(m => m.AvailabilityPageModuleNgFactory), ɵ112 = { title: "routeTitles.serviceRequest" }, ɵ113 = () => import("./_modules/forms/gardening/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ114 = { title: "routeTitles.coqueForm" }, ɵ115 = () => import("./_modules/forms/coque/form.module.ngfactory").then(m => m.FormPageModuleNgFactory), ɵ116 = { title: "routeTitles.tragaLuzForm" }, ɵ117 = () => import("./_modules/forms/traga-luz/form.module.ngfactory").then(m => m.FormPageModuleNgFactory);
const routes = [
    // Public routes
    {
        path: "",
        redirectTo: "/" + environment.defaultLang,
        pathMatch: "full"
    },
    {
        path: ":locale",
        data: ɵ0,
        loadChildren: ɵ1,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/recovery",
        data: ɵ2,
        loadChildren: ɵ3,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/change-password/:token",
        data: ɵ4,
        loadChildren: ɵ5,
        canActivate: [PublicRedirectionGuard]
    },
    {
        path: ":locale/santander-portugal-autologin-token",
        data: ɵ6,
        loadChildren: ɵ7,
        canActivate: [PublicRedirectionGuard]
    },
    // Protected routes
    {
        path: ":locale/about",
        data: ɵ8,
        loadChildren: ɵ9,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/beneficiaries",
        data: ɵ10,
        loadChildren: ɵ11,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/faq",
        data: ɵ12,
        loadChildren: ɵ13,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/id-4",
        data: ɵ14,
        loadChildren: ɵ15,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/id-5",
        data: ɵ16,
        loadChildren: ɵ17,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-index",
        data: ɵ18,
        loadChildren: ɵ19,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-details/:id",
        data: ɵ20,
        loadChildren: ɵ21,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-availability/:id",
        data: ɵ22,
        loadChildren: ɵ23,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-availability-static/:id",
        data: ɵ24,
        loadChildren: ɵ25,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id",
        data: ɵ26,
        loadChildren: ɵ27,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/contact",
        data: ɵ28,
        loadChildren: ɵ29,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/feature/:id",
        data: ɵ30,
        loadChildren: ɵ31,
    },
    {
        path: ":locale/sociosanitary",
        data: ɵ32,
        loadChildren: ɵ33,
        canActivate: [SociosanitaryGuard, AuthGuard]
    },
    {
        path: ":locale/personal-area",
        data: ɵ34,
        loadChildren: ɵ35,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/my-data",
        data: ɵ36,
        loadChildren: ɵ37,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/my-services",
        data: ɵ38,
        loadChildren: ɵ39,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/my-beneficiaries",
        data: ɵ40,
        loadChildren: ɵ41,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/request-details/:id",
        data: ɵ42,
        loadChildren: ɵ43,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/personal-area/stock-details/:publicUuid",
        data: ɵ44,
        loadChildren: ɵ45,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/search-airport",
        data: ɵ46,
        loadChildren: ɵ47,
        canActivate: [FlowNavigationGuard, AuthGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/terminal-details",
        data: ɵ48,
        loadChildren: ɵ49,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/resource-details",
        data: ɵ50,
        loadChildren: ɵ51,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/check-availability",
        data: ɵ52,
        loadChildren: ɵ53,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip/form",
        data: ɵ54,
        loadChildren: ɵ55,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/salas-vip-whatsapp/form",
        data: ɵ56,
        loadChildren: ɵ57,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/fast-track/form",
        data: ɵ58,
        loadChildren: ɵ59,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/beauty/form",
        data: ɵ60,
        loadChildren: ɵ61,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/hairdressing/form",
        data: ɵ62,
        loadChildren: ɵ63,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/force-error",
        data: ɵ64,
        loadChildren: ɵ65,
        canActivate: [AuthGuard]
    },
    {
        path: ":locale/service-request/:id/esim-flag/check-availability",
        data: ɵ66,
        loadChildren: ɵ67,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/esim-flag/form",
        data: ɵ68,
        loadChildren: ɵ69,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/transfer/check-availability",
        data: ɵ70,
        loadChildren: ɵ71,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/transfer/form",
        data: ɵ72,
        loadChildren: ɵ73,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/transfer/uber-form",
        data: ɵ74,
        loadChildren: ɵ75,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/handyman/check-availability",
        data: ɵ76,
        loadChildren: ɵ77,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-generic-companions/check-availability",
        data: ɵ78,
        loadChildren: ɵ79,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-generic-companions/form",
        data: ɵ80,
        loadChildren: ɵ81,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-exclusive-companions/check-availability",
        data: ɵ82,
        loadChildren: ɵ83,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-exclusive-companions/form",
        data: ɵ84,
        loadChildren: ɵ85,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-generic/check-availability",
        data: ɵ86,
        loadChildren: ɵ87,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-generic/form",
        data: ɵ88,
        loadChildren: ɵ89,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-exclusive/check-availability",
        data: ɵ90,
        loadChildren: ɵ91,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/experience-exclusive/form",
        data: ɵ92,
        loadChildren: ɵ93,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/physiotherapy/form",
        data: ɵ94,
        loadChildren: ɵ95,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/physiotherapy-justification/form",
        data: ɵ96,
        loadChildren: ɵ97,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/psychology/form",
        data: ɵ98,
        loadChildren: ɵ99,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/handyman/form",
        data: ɵ100,
        loadChildren: ɵ101,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/sad/check-availability",
        data: ɵ102,
        loadChildren: ɵ103,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/sad/form",
        data: ɵ104,
        loadChildren: ɵ105,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/carpentry/check-availability",
        data: ɵ106,
        loadChildren: ɵ107,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/carpentry/form",
        data: ɵ108,
        loadChildren: ɵ109,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/gardening/check-availability",
        data: ɵ110,
        loadChildren: ɵ111,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/gardening/form",
        data: ɵ112,
        loadChildren: ɵ113,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/coque/form",
        data: ɵ114,
        loadChildren: ɵ115,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: ":locale/service-request/:id/traga-luz/form",
        data: ɵ116,
        loadChildren: ɵ117,
        canActivate: [AuthGuard, FlowNavigationGuard]
    },
    {
        path: "**",
        redirectTo: "/" + environment.defaultLang,
        pathMatch: "full"
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40, ɵ41, ɵ42, ɵ43, ɵ44, ɵ45, ɵ46, ɵ47, ɵ48, ɵ49, ɵ50, ɵ51, ɵ52, ɵ53, ɵ54, ɵ55, ɵ56, ɵ57, ɵ58, ɵ59, ɵ60, ɵ61, ɵ62, ɵ63, ɵ64, ɵ65, ɵ66, ɵ67, ɵ68, ɵ69, ɵ70, ɵ71, ɵ72, ɵ73, ɵ74, ɵ75, ɵ76, ɵ77, ɵ78, ɵ79, ɵ80, ɵ81, ɵ82, ɵ83, ɵ84, ɵ85, ɵ86, ɵ87, ɵ88, ɵ89, ɵ90, ɵ91, ɵ92, ɵ93, ɵ94, ɵ95, ɵ96, ɵ97, ɵ98, ɵ99, ɵ100, ɵ101, ɵ102, ɵ103, ɵ104, ɵ105, ɵ106, ɵ107, ɵ108, ɵ109, ɵ110, ɵ111, ɵ112, ɵ113, ɵ114, ɵ115, ɵ116, ɵ117 };
